import mobileCarousel from "../modules/utils/mobileCarousel";
mobileCarousel('section-icons-brands__slider-wrapper', false, 1.5, 0, false);